<!-- Dialog Content -->
@if (isWithinDialog) {
<h2 mat-dialog-title>{{ title }}</h2>
<mat-dialog-content>
  <ng-container *ngTemplateOutlet="table"></ng-container>
</mat-dialog-content>
<mat-dialog-actions>
  <button ctx-button--primary [matDialogClose]>Close</button>
</mat-dialog-actions>
} @else {
<ng-container *ngTemplateOutlet="table"></ng-container>
}

<!-- Content Without Dialog -->

<!-- Table Content -->
<ng-template #table>
  @if (arrayOfObjects && arrayOfObjects.length > 0) {
  <section class="overflow-auto max-h-96 rounded-lg" tabindex="0">
    <table mat-table class="mat-table--object" [dataSource]="arrayOfObjects">
      <!-- Properties -->
      @for (property of columnsToDisplay; track property; let last = $last) {
      <ng-container [matColumnDef]="property">
        <th mat-header-cell *matHeaderCellDef [ngClass]="last ? 'w-full' : ''">
          <span class="whitespace-nowrap">
            {{ getResourceDisplayName(property) }}
          </span>
        </th>
        <td
          mat-cell
          class="ph-no-capture"
          [ngClass]="last ? 'w-full' : ''"
          *matCellDef="let element"
        >
          {{ formatCellValue(element, property) }}
        </td>
      </ng-container>
      }
      <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
    </table>
  </section>
  } @else {
  <section class="flex flex-row gap-1">
    <hlm-icon name="WARNING" inline></hlm-icon>
    <p>The requested resource is empty.</p>
  </section>
  }
  <ng-template #empty>
    <section class="flex flex-row gap-1">
      <hlm-icon name="WARNING" inline></hlm-icon>
      <p>The requested resource is empty.</p>
    </section>
  </ng-template>
</ng-template>
